const replaceApiIri = (iri: string, collection: string) =>
  iri.replace(`/api/${collection}/`, '');

export default replaceApiIri;
